import { BASEURL, checktoken, headers } from '../../utils/helper'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError, toastSuccess } from './other.slice';
import axios from 'axios';

const initialState = {
    services: [],
    service: {},
    total: 0,
    pages: 0,
    current: 0,
    error: null,
    uloader: false,
    loading: false,
}

export const createServiceReq = createAsyncThunk('createServiceReq', async ({ data, navigate }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.post(`${BASEURL}/admin/service/create`, data,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                    navigate('/admin/services')
                }
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const listServiceReq = createAsyncThunk('listServiceReq', async ({ text }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/service/list?text=${text}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const singleServiceReq = createAsyncThunk('singleServiceReq', async ({ id }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/service/info/${id}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const updateServiceReq = createAsyncThunk('updateServiceReq', async ({ id, data, navigate }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.put(`${BASEURL}/admin/service/update/${id}`, data,
            { headers: headers() })
            .then((res) => {
                if (res.data.success) {
                    dispatch(toastSuccess('Service updated!'))
                    navigate('/admin/services')
                }
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const deleteServiceReq = createAsyncThunk('deleteServiceReq', async ({ id, text }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.delete(`${BASEURL}/admin/service/delete/${id}`,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res.data.message))
                    dispatch(listServiceReq({ text }))
                }
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})


export const ServiceSlice = createSlice({
    name: 'serviceSlice',
    initialState: initialState,
    extraReducers: (builder) => {
        builder.addCase(createServiceReq.pending, (state, action) => {
            state.uloader = true
            return state
        })
        builder.addCase(createServiceReq.fulfilled, (state, action) => {
            state.uloader = false
            return state
        })
        builder.addCase(createServiceReq.rejected, (state, action) => {
            state.uloader = false
            state.error = 'Error occured'
        })
        builder.addCase(listServiceReq.pending, (state, action) => {
            state.loading = true
            state.total = 0
            state.pages = 0
            state.current = 0
            state.services = []
            return state
        })
        builder.addCase(listServiceReq.fulfilled, (state, action) => {
            state.loading = false
            state.total = action.payload.data?.total
            state.pages = action.payload.data?.pages
            state.current = action.payload.data?.current
            state.services = action.payload.data?.services
            return state
        })
        builder.addCase(listServiceReq.rejected, (state, action) => {
            state.loading = false
            state.total = 0
            state.pages = 0
            state.current = 0
            state.services = []
            state.error = 'Error occured'
        })
        builder.addCase(singleServiceReq.pending, (state, action) => {
            state.loading = true
            state.service = {}
            return state
        })
        builder.addCase(singleServiceReq.fulfilled, (state, action) => {
            state.loading = false
            state.service = action.payload.data
            return state
        })
        builder.addCase(singleServiceReq.rejected, (state, action) => {
            state.loading = false
            state.service = {}
            state.error = 'Error occured'
        })
        builder.addCase(updateServiceReq.pending, (state, action) => {
            state.uloader = true
            return state
        })
        builder.addCase(updateServiceReq.fulfilled, (state, action) => {
            state.uloader = false
            state.service = {}
            return state
        })
        builder.addCase(updateServiceReq.rejected, (state, action) => {
            state.uloader = false
            state.error = 'Error occured'
        })
        // builder.addCase(assignUserRoleReq.pending, (state, action) => {
        //     state.uloader = true
        //     return state
        // })
        // builder.addCase(assignUserRoleReq.fulfilled, (state, action) => {
        //     state.uloader = false
        //     return state
        // })
        // builder.addCase(assignUserRoleReq.rejected, (state, action) => {
        //     state.uloader = false
        //     state.error = 'Error occured'
        // })
        builder.addCase('LOGOUT', () => initialState)
    }
})

export default ServiceSlice.reducer